export enum StudyPlanEvents {
  STUDY_PLAN_SAVED = 'study_plan_saved',
  STUDY_PLAN_CONTINUE = 'study_plan_continue',
  STUDY_PLAN_BACK = 'study_plan_back',
}
